mainApp.component('discoveryPage', {
    templateUrl: '/public/components/discovery/discovery-page.component.html',
    controller: function($state, $timeout, $scope, $rootScope, $filter, DateRangeService, DiscoveryQueryService, UserContextService, $sce, ProgressBarService) {
        const NUM_OF_BUCKETS = 60;
        const ctrl = this;

        ctrl.$onInit = function() {
        }

        ctrl.startProgress = function(progress){
            ctrl.progressId = progress.id;
            ctrl.progress = progress;
            ctrl.cancelExport = true;
        }

        ctrl.switchToNewUi = function () {
            $rootScope.saveChoiceAndJumpToAmazingUi();
        }

        ctrl.closeModal = function () {
            $rootScope.closePopup("events-discovery-ui-switch-modal");
        }

        $rootScope.openPopup("events-discovery-ui-switch-modal");

        ctrl.setSelectedPreset = function(value, $event) {
            ctrl.selectedFields = value.selectedFields;
            ctrl.sortFields = value.sortFields;

            ctrl.filters = [];
            value.filters.forEach(f => ctrl.addFilterWithoutStateRefresh(f.field, f.operator, f.value));

            ctrl.refreshState(true, true);
        }

        ctrl.fetchAllESData = function(shouldFetchCardinality, shouldFetchHistogram) {
            if (shouldFetchCardinality) {
                ctrl.fetchAllDataFieldsCardinality();
            }

            ctrl.fetchData();

            if (shouldFetchHistogram) {
                ctrl.fetchDataHistogram();
            }
        }

        ctrl.fetchAllData = function(shouldFetchCardinality, shouldFetchHistogram) {
            if (!ctrl.fieldsSpec) {
                ctrl.fetchSpec(function () {
                    if ($state.params.filter && (!$state.params.queryChanged || $state.params.queryChanged === 'false')) {
                        const filter = angular.fromJson($state.params.filter);
                        if (filter.name && filter.type) {
                            var nameFound = false;
                            var typeFound = false;

                            ctrl.filters.forEach(f => {
                                if (f.field === 'source_name') {
                                    nameFound = true;
                                } else if (f.field === 'client_type') {
                                    typeFound = true;
                                }
                            });

                            if (!nameFound && !typeFound) {
                                ctrl.addFilterWithoutStateRefresh('src_site_name', 'is', filter.name);
                                ctrl.addFilter('src_is_site_or_vpn', 'is', filter.type === 'login' ? 'VPN User' : 'Site');
                            }
                        }
                    } else {
                        ctrl.fetchAllESData(shouldFetchCardinality, shouldFetchHistogram);
                    }
                });
            } else {
                ctrl.fetchAllESData(shouldFetchCardinality, shouldFetchHistogram);
            }
        }

        ctrl.fetchSpec = function(onSuccess) {
            store.fetch({
                method: 'POST',
                path: '/discoverSpec/events?accountId=' + $state.params.accountId,
                success: function(data) {
                    ctrl.fieldsSpec = data;

                    ctrl.fieldsSpec['time'].constant = true;
                    ctrl.fieldsSpec['time'].sortable = true;
                    ctrl.fieldsSpec['time'].colSpan = 2;
                    ctrl.fieldsSpec['event_data'] = {
                        presentation: 'event data',
                        constant: true,
                        sortable: false,
                    }

                    $scope.$digest();

                    onSuccess();
                }
            });
        }

        ctrl.fetchData = function() {
            ctrl.docs = null;

            const discoveryConfig = {
                fromTime: ctrl.cdr.from,
                toTime: ctrl.cdr.to,
                filters: ctrl.filters,
                sort: ctrl.sortFields,
            }

            store.fetch({
                method: 'POST',
                path: '/discoverData/events?accountId=' + $state.params.accountId,
                data: discoveryConfig,
                dataObj: 'discoveryConfig',
                success: function(data) {
                    ctrl.docs = data.docs;

                    if (ctrl.sortFields.length === 0)
                        ctrl.docs.sort((d1, d2) => d2.time - d1.time);

                    $scope.$digest();
                }
            });
        }

        ctrl.fetchAllDataFieldsCardinality = function() {
            ctrl.fieldsCardinality = {};

            ctrl.fieldsUsage = {
                fieldToUsages: {},
                fieldToSuggestions: {},
                total: ctrl.totalCount
            };

            let fieldGroups = [];
            let fields = Object.keys(ctrl.fieldsSpec);
            let groupSize = fields.length; // We can control the amount of fields to be fetched in each batch for performance optimizations
            let groups = Math.trunc(fields.length / groupSize);
            for (let i = 0; i < groups; i++) {
                fieldGroups.push([]);
            }

            fields.forEach(function(field, idx) {
                fieldGroups[idx % groups].push(field);
            });

            fieldGroups.forEach(function(fields) {
                ctrl.fetchDataFieldCardinality(fields);
            })
        }

        ctrl.fetchDataFieldCardinality = function(fields) {
            const fieldUsagesConfig = {
                fromTime: ctrl.cdr.from,
                toTime: ctrl.cdr.to,
                filters: ctrl.filters,
                fields: fields
            }

            store.fetch({
                method: 'POST',
                path: '/discoverDataFieldCardinality/events?accountId=' + $state.params.accountId,
                data: fieldUsagesConfig,
                dataObj: 'fieldCardinalityConfig',
                success: function(data) {
                    let tmp = ctrl.fieldsCardinality;
                    _.forOwn(data.fieldToCardinality, function(value, key) {
                        tmp[key] = value;
                    });

                    ctrl.fieldsCardinality = {};
                    _.forOwn(tmp, function(value, key) {
                        ctrl.fieldsCardinality[key] = value;
                    });
                    ctrl.disableExport = false;
                    $scope.$digest();
                }
            });
        }

        ctrl.fetchDataHistogram = function() {
            ctrl.aggs = null;
            ctrl.totalCount = null;

            const histogramConfig = {
                fromTime: ctrl.cdr.from,
                toTime: ctrl.cdr.to,
                filters: ctrl.filters,
                histogramInterval: ctrl.cdr.bucketDuration,
            }

            store.fetch({
                method: 'POST',
                path: '/discoverDataHistogram/events?accountId=' + $state.params.accountId,
                data: histogramConfig,
                dataObj: 'histogramConfig',
                success: function(data) {
                    ctrl.aggs = data.aggBuckets;
                    ctrl.totalCount = data.total;
                    if (!ctrl.fieldsUsage) {
                        ctrl.fieldsUsage = {
                            fieldToUsages: {},
                            fieldToSuggestions: {},
                            total: ctrl.totalCount
                        };
                    } else {
                        ctrl.fieldsUsage.total = data.total;
                    }

                    $scope.$digest();
                }
            });
        }

        ctrl.fetchUsages = function(field, amount) {
            ctrl.fetchDataFieldsUsages([field], amount);
        }

        ctrl.fetchDataFieldsUsages = function(fields, amount) {
            const fieldUsagesConfig = {
                fromTime: ctrl.cdr.from,
                toTime: ctrl.cdr.to,
                filters: ctrl.filters,
                fields: fields,
                amount: amount
            }

            store.fetch({
                method: 'POST',
                path: '/discoverDataFieldUsages/events?accountId=' + $state.params.accountId,
                data: fieldUsagesConfig,
                dataObj: 'fieldUsagesConfig',
                success: function(data) {
                    if (!ctrl.fieldsUsage) {
                        ctrl.fieldsUsage = {
                            fieldToUsages: {},
                            fieldToSuggestions: {},
                            total: ctrl.totalCount
                        };
                    }

                    _.forOwn(data.fieldToUsages, function(value, key) {
                        ctrl.fieldsUsage.fieldToUsages[key] = value;
                    });

                    ctrl.fieldsUsage = {
                        fieldToUsages: ctrl.fieldsUsage.fieldToUsages,
                        fieldToSuggestions: ctrl.fieldsUsage.fieldToSuggestions,
                        total: ctrl.totalCount
                    };

                    $scope.$digest();
                }
            });
        }

        ctrl.fetchDataFieldFilterSuggestions = function(field) {
            const fieldFilterSuggestionsConfig = {
                fromTime: ctrl.cdr.from,
                toTime: ctrl.cdr.to,
                filters: ctrl.filters,
                field: field
            }

            store.fetch({
                method: 'POST',
                path: '/discoverDataFieldFilterSuggestions/events?accountId=' + $state.params.accountId,
                data: fieldFilterSuggestionsConfig,
                dataObj: 'fieldFilterSuggestionsConfig',
                success: function(data) {
                    _.forOwn(data.fieldToSuggestions, function(value, key) {
                        ctrl.fieldsUsage.fieldToSuggestions[key] = value;
                    });

                    ctrl.fieldsUsage = {
                        fieldToUsages: ctrl.fieldsUsage.fieldToUsages,
                        fieldToSuggestions: ctrl.fieldsUsage.fieldToSuggestions,
                        total: ctrl.totalCount
                    };

                    $scope.$digest();
                }
            });
        }

        ctrl.addColumn = function(field) {
            if (!ctrl.selectedFields.includes(field)) {
                if (ctrl.selectedFields[1] === 'event_data') {
                    ctrl.selectedFields.splice(1, 1);
                }

                ctrl.selectedFields.push(field);

                ctrl.refreshState(false);
            }
        }

        ctrl.removeColumn = function(field) {
            ctrl.selectedFields.splice(_.findIndex(ctrl.selectedFields, col => col === field), 1);

            if (ctrl.selectedFields.length === 1) {
                ctrl.selectedFields.push('event_data');
            }

            ctrl.refreshState(false);
        }

        ctrl.moveColumn = function(field, direction) {
            const colIdx = ctrl.selectedFields.indexOf(field);
            const targetcolIdx = colIdx + (direction === 'right' ? 1 : -1);
            [ctrl.selectedFields[colIdx], ctrl.selectedFields[targetcolIdx]] =
                [ctrl.selectedFields[targetcolIdx], ctrl.selectedFields[colIdx]];
        }

        ctrl.sortByColumn = function(field) {
            if (ctrl.sortFields[0] && ctrl.sortFields[0].field === field) {
                if (ctrl.sortFields[0].order === 'asc') {
                    ctrl.sortFields[0].order = 'desc';
                } else {
                    ctrl.sortFields[0].order = 'asc';
                }
            } else {
                ctrl.sortFields = [{
                    field: field,
                    order: 'asc'
                }];
            }

            ctrl.fetchAllData(false, false);
        }

        ctrl.getPresentationValue = function(field, operatorDef, value) {
            if (operatorDef.type === 'value') {
                return ctrl.fieldValueFormatter(field, value);
            }

            if (operatorDef.type === 'list') {
                return '[' + value.map(v => ctrl.fieldValueFormatter(field, v)).join(', ') + ']';
            }

            if (operatorDef.type === 'range') {
                return ctrl.fieldValueFormatter(field, value.from) + ' and ' + ctrl.fieldValueFormatter(field, value.to);
            }

            if (operatorDef.type === 'boolean') {
                return '';
            }
        }

        ctrl.refreshState = function(queryChanged, shouldFetchData) {
            $state.go('.', {
                query: angular.toJson(ctrl.filters),
                queryChanged: queryChanged,
                selectedFields: angular.toJson(ctrl.selectedFields),
            }, {
                notify: false,
                reload: false
            });

            if (shouldFetchData) {
                ctrl.fetchAllData(true, true);
            }
        }

        ctrl.getFilterObject = function(field, operator, value) {
            const operatorDef = DiscoveryQueryService.getOperatorDefinition(operator);

            return {
                field: field,
                operator: operator,
                spec: operatorDef.spec,
                value: value,

                description: ctrl.fieldsSpec[field].presentation + ' ' + operatorDef.descriptor  + ' ' + ctrl.getPresentationValue(field, operatorDef, value)
            };
        }

        function addFilterIfNotPresentAlready(field, operator, val) {
            let similarFilter = ctrl.filters.filter(i => i.field === field && i.operator === operator && i.value === val);

            if (similarFilter.length > 0)
                return;

            ctrl.filters.push(ctrl.getFilterObject(field, operator, val));
        }

        ctrl.addFilterWithoutStateRefresh = function(field, operator, value) {
            // in case there is an array for operator 'value' type it means that there should be multiple
            // (and) filters added (one for each value in the array e.g. categories field), otherwise it is
            // one (or) filter with multiple possible values
            if (Array.isArray(value) && operator === 'is') {
                value.forEach(val => {
                    addFilterIfNotPresentAlready(field, operator, val);
                });
            } else {
                addFilterIfNotPresentAlready(field, operator, value);
            }

            // hack so one way bindings in child components will recognize that the array changed
            ctrl.filters = ctrl.filters.filter(i => true);
        }

        ctrl.addFilter = function(field, operator, value) {
            ctrl.addFilterWithoutStateRefresh(field, operator, value)
            ctrl.refreshState(true, true);
        }

        ctrl.removeFilter = function(deleted) {
            ctrl.filters = ctrl.filters.filter(i => i.field !== deleted.field || i.operator !== deleted.operator || i.value !== deleted.value);

            ctrl.refreshState(true, true);
        }

        ctrl.changeFilter = function(prevItem, field, operator, value) {
            ctrl.filters = ctrl.filters.filter(i => i.field !== prevItem.field || i.operator !== prevItem.operator || i.value !== prevItem.value);

            ctrl.filters.push(ctrl.getFilterObject(field, operator, value));

            ctrl.refreshState(true, true);
        }

        ctrl.changeTimeRange = function(from, to) {
            ctrl.cdr.from = Math.min(from, to);
            ctrl.cdr.to = Math.max(from, to);

            DateRangeService.zoomToDateRange(ctrl.cdr);

            return false;
        }

        ctrl.expandedHits = [];

        ctrl.fetchAlertBody = function (doc) {
            const discoveryConfig = {
                fromTime: ctrl.cdr.from,
                toTime: ctrl.cdr.to,
                filters: [{
                    field: 'events.internalId',
                    spec: 'mustMatchPhrase',
                    value: doc.internalId
                }],
            }

            store.fetch({
                method: 'POST',
                path: '/discoverData/alerts?accountId=' + $state.params.accountId,
                data: discoveryConfig,
                dataObj: 'discoveryConfig',
                success: function(data) {
                    doc.alert = data;

                    $scope.$digest();
                }
            });
        }

        ctrl.toggleDocExpansion = function(hitIdx) {
            if (ctrl.isExpandedDoc(hitIdx)) {
                const idx = ctrl.expandedHits.indexOf(hitIdx);
                if (idx > -1) {
                    ctrl.expandedHits.splice(idx, 1);
                }
            } else {
                ctrl.expandedHits.push(hitIdx);
                ctrl.fetchAlertBody(ctrl.docs[hitIdx]);
            }
        }

        ctrl.isExpandedDoc = function(hitIdx) {
            return ctrl.expandedHits.includes(hitIdx);
        }

        ctrl.fieldValueFormatter = function(field, value) {
            if (Array.isArray(value))
                return ctrl.formatterForType.arrayOfKeywords(value);
            return (field !== '_source' && field !== 'alert' && ctrl.formatterForType[ctrl.fieldsSpec[field].type] && ctrl.formatterForType[ctrl.fieldsSpec[field].type](value)) || value;
        }

        ctrl.getDocsLimit = function() {
            return 100;
        }

        ctrl.getCountOfRows = function() {
            return 1 + (ctrl.docs ? Math.min(ctrl.docs.length, ctrl.getDocsLimit()) : 0) + ctrl.expandedHits.length;
        }
    },
});
